import React, { useCallback, useMemo, useRef } from "react";
import { isSet } from "../../../Utils/CommonFunctions";
import ScmInputTextField from "./ScmInputTextField";
import { extractStylesAsObjects } from "../MarkupFunctions";

const ScmFormInputWrapper = ({ inputChild, formName, divIndex, formData, handleNestedInputChange, elmtParams, defProps }) => {
    const attributesOfChild = isSet(inputChild.attribs, {});
    const inputName = isSet(attributesOfChild?.name, '');
    const inputType = isSet(attributesOfChild?.type, 'TextInput');
    const currentValue = formData[divIndex]?.[inputName] || '';
    
    // Create stable handler function
    const handleInputChange = useCallback((objFromScmInputTextField, valFromScmInputTextField) => {
        handleNestedInputChange(inputName, valFromScmInputTextField, divIndex);
    }, [inputName, divIndex, handleNestedInputChange]);
    
    // Memoize nestedDefProps but don't include currentValue in dependencies
    // currentValue will be read directly when needed, not as dependency
    const nestedDefProps = useMemo(() => ({
        ...defProps,
        onChangeResourcesFieldHandler: handleInputChange,
        fieldFormPayload: {
            [inputName]: { selected_value: currentValue, api_name: inputName }
        }
    }), [defProps, handleInputChange, inputName]); // Removed currentValue from dependencies

    // Use ref to track previous value to update fieldFormPayload when needed
    const prevValueRef = useRef(currentValue);
    
    // Update fieldFormPayload only when value actually changes
    if (prevValueRef.current !== currentValue) {
        prevValueRef.current = currentValue;
        nestedDefProps.fieldFormPayload[inputName].selected_value = currentValue;
    }

    const elmtParamsForScmInput = useMemo(() => ({
        convertAndRenderElement: elmtParams.convertAndRenderElement,
        dynamicVar: elmtParams.dynamicVar,
        children: inputChild.children,
        formScope: formName,
        divName: `${formName}_div_${divIndex}`,
        defProps: nestedDefProps
    }), [elmtParams.convertAndRenderElement, elmtParams.dynamicVar, inputChild.children, formName, divIndex, nestedDefProps]);

    const styleString = isSet(attributesOfChild?.style, '');
    const styleObject = typeof styleString === 'string' ? extractStylesAsObjects(styleString) : styleString;

    const updatedAttributes = {
        ...attributesOfChild,
        style: styleObject
    };

    return (
        <ScmInputTextField
            key={`${formName}_${inputName}_${divIndex}`}
            attributes={updatedAttributes}
            elmtParams={elmtParamsForScmInput}
        />
    );
};
export default ScmFormInputWrapper;
